import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import useAuthStore from '../stores/authStore'

const ProtectedRoute = ({ children }) => {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated)
  const location = useLocation()

  console.log('🔐 ProtectedRoute check:', { 
    isAuthenticated, 
    pathname: location.pathname,
    willRedirect: !isAuthenticated 
  })

  if (!isAuthenticated) {
    console.log('🚨 Not authenticated - redirecting to login')
    // Save the attempted location
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  console.log('✅ Authenticated - rendering children')
  return children
}

export default ProtectedRoute